module.exports = TipTap.StarterKit;


//////////////////
// WEBPACK FOOTER
// external "TipTap.StarterKit"
// module id = 481
// module chunks = 0 1